import CategoryView from '@/pages/category/components/CategoryView';

export default function TvCategoryPage() {
  return (
    <CategoryView
      type="tv"
      title="电视剧分类"
      description="热播剧集与完结好剧一站浏览，支持按类型、年份、地区与集数筛选，助你轻松追剧。"
      bannerImage="https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20living%20room%20at%20night%20with%20a%20glowing%20television%20screen%20casting%20warm%20light%2C%20cozy%20atmospheric%20mood%2C%20deep%20blue%20and%20amber%20tones%2C%20no%20text&width=1600&height=500&seq=category-tv-banner-02&orientation=landscape"
    />
  );
}